import { AppBar } from "Components/NavBar/Navbar";
import { Sidebar } from "Components/SideBar/Sidebar";
import {
  ToastContextDispatch,
  UserInfoContext,
  SuccessfullyMessageBarContext,
  UserInfoContextDispatch,
  VersionUpdateMessageBarDispatch,
  VersionUpdateMessageBarContext,
} from "Context/CommonContext";
import routes, { dynamicRoutes } from "Layout/routes";
import { useContext, useEffect, useState } from "react";
import { Navigate, Route, useOutlet } from "react-router-dom";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import {
  BASE_URL,
  FETCH_REGION,
  GET_ACAD_YEAR,
  GET_BOARD,
  GET_BRANCH,
  GET_CLASS,
  GET_STREAMS,
  GET_SUBJECTS,
  GET_USER_INFO,
  GET_TEST_TYPE,
  GET_PHASE,
} from "utilFunctions/Constants/urlConstants";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import SuccessfullyMessageBar from "Layout/SuccessfullyMessageBar";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import useMasterContext from "Context/MasterContext";
import { mapToArrayForSelect } from "utilFunctions/helperFunctions/HelperFunction";
// import StudentprofileHome from "Pages/BranchHealth/Student/StudentProfileHome";
import { sendRefreshEventToGTAG } from "utilFunctions/helperFunctions/analytics";
import RequireAuth from "utilFunctions/RequireAuth";
import CustomModal from "Components/CommonComponents/CustomModal";
import Typography from "Components/CommonComponents/Typography";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { storeQuestionFilter } from "redux/action/questionAction";

const ContainerDivAdmin = styled<any>("div")`
  padding-left: ${(props: any) => (props.width > 1200 ? "60px" : "0px")};
`;
const classUrl = BASE_URL + GET_CLASS;
const streamUrl = BASE_URL + GET_STREAMS;
const acadyearUrl = BASE_URL + GET_ACAD_YEAR;
const subjectUrl = BASE_URL + GET_SUBJECTS;
const phaseUrl = BASE_URL + GET_PHASE;
const branchUrl = BASE_URL + GET_BRANCH;
const boardUrl = BASE_URL + GET_BOARD;
const regionUrl = BASE_URL + FETCH_REGION;
const testTypeUrl = BASE_URL + GET_TEST_TYPE;

export const ProtectedLayout = () => {
  const [sidenavOpen, setSidenavOpen] = useState(false);
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const userinfoDispatch = useContext<any>(UserInfoContextDispatch);
  const { saveMasterData } = useMasterContext();
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarContext);
  const VersionUpdateDispatch = useContext<any>(
    VersionUpdateMessageBarDispatch
  );
  const versionUpdateNeeded = useContext<any>(VersionUpdateMessageBarContext);
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const outlet = useOutlet();
  const { screen, windowSize }: any = useWindowSize();
  const { width } = windowSize;
  const { user, logout } = useAuth();
  const dispatch = useDispatch();
  const [isMiniSideBar, setIsMiniSideBar] = useState<boolean>(false);
  const [showNotification, setShowNotification] = useState(false);
  const IsVersionUpdateNeeded = localStorage.getItem("version-update-needed");
  useEffect(() => {
    const itemKey = "insightObject";
    const lastVisitKey = "lastVisitDate";

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const lastVisitDateString = localStorage.getItem(lastVisitKey);
    let lastVisitDate: Date | null = null;

    if (lastVisitDateString) {
      lastVisitDate = new Date(lastVisitDateString);
    }
    if (lastVisitDate && lastVisitDate < today) {
      localStorage.removeItem(itemKey);
    }

    localStorage.setItem(lastVisitKey, today.toString());
  }, []);
  useEffect(() => {
    getuserInfo(userInfo);
  }, []);
  useEffect(() => {
    if (IsVersionUpdateNeeded == "true") {
      VersionUpdateDispatch({
        isShow: true,
        message:
          "A new version of Aakash Guru is available. Click Update to start using the latest version.",
      });
    }
  }, [IsVersionUpdateNeeded]);
  useEffect(() => {
    if (window.location.hash.includes("#/admin/question")) {
      return;
    } else {
      dispatch(storeQuestionFilter());
    }
  }, [window.location.href]);
  useEffect(() => {
    getMasterData(streamUrl, "streams", {
      label: "stream",
      key: "id",
      value: "id",
    });
    getMasterData(classUrl, "classes", {
      label: "class",
      key: "id",
      value: "id",
    });
    getMasterData(acadyearUrl, "acadYears", {
      label: "session",
      key: "id",
      value: "id",
    });
    getMasterData(acadyearUrl, "userAcadYear", {
      label: "session",
      key: "id",
      value: "id",
    });
    getMasterData(subjectUrl, "subjects", {
      label: "subject",
      key: "id",
      value: "id",
    });
    getMasterData(branchUrl, "branches", {
      label: "branchName",
      key: "branchId",
      value: "id",
    });
    getMasterData(boardUrl, "boards", {
      label: "boardName",
      key: "id",
      value: "id",
    });
    getMasterData(regionUrl, "regions", {
      label: "region",
      key: "id",
      value: "id",
    });
    getMasterData(testTypeUrl, "testTypes", {
      label: "testType",
      key: "id",
      value: "id",
    });
    getMasterData(phaseUrl, "phases", {
      label: "phaseName",
      key: "phase",
      value: "id",
    });
  }, [userInfo?.id]);
  const userBranchArray: any = userInfo?.branch?.split(",").map(Number) || [];
  const getMasterData = async (url: string, key: string, object: any) => {
    const id = userInfo?.id;
    if (["classes", "subjects"].includes(key)) {
      const streamIdArray: any = JSON.parse(
        localStorage.getItem("idToStreamName") as any
      );
      const streamIds: any =
        streamIdArray && streamIdArray.map((item: any) => item.value);
      url = url + "?userStreamIds=" + streamIds;
    }
    if (id) {
      await getAPIRequest({
        url: url,
        success: (response: any) => {
          const data = response?.data?.data;
          const newArray: selectInterface[] = [];
          if (key == "classes") {
            data?.sort((a: any, b: any) =>
              a.class < b.class ? 1 : b.class < a.class ? -1 : 0
            );
          }
          data.map((ele: any) => {
            if (
              key == "streams" &&
              !["SOE", "SOM", "SOF"].includes(ele[object?.label])
            ) {
              return;
            } else if (key == "acadYears" && ele[object?.label] < "2023") {
              return;
            } else if (key == "regions") {
              newArray.push({
                label: ele["region"],
                regionCode: ele["regionCode"],
                key: ele["id"],
                id: ele["id"],
                value: ele["regionCode"],
              });
            } else {
              newArray.push({
                label:
                  key == "branches"
                    ? ele[object?.label] + "-" + ele?.[object?.key]
                    : ele[object?.label],
                key: ele[object?.key],
                value:
                  key == "branches"
                    ? ele?.[object?.key] && ele?.[object?.key].slice(2) == ""
                      ? ele?.[object?.key]
                      : key == "branches" &&
                        ele?.[object?.key] &&
                        ele?.[object?.key].slice(2) != ""
                      ? ele?.[object?.key].slice(2)
                      : ele?.[object?.value]
                    : ele?.[object?.value],
                region: key == "branches" ? ele["region"] : "",
                regionCode: key == "branches" ? ele["regionCode"] : "",
                id: ele["id"],
              });
            }
          });
          if (key == "branches") {
            const arr: any = [];
            [...data].forEach((ele: any) => {
              if (userBranchArray.includes(ele.id)) {
                arr.push({
                  label: ele["branchName"] + "-" + ele?.["branchId"],
                  value: ele?.["branchId"],
                  key: ele?.["branchId"],
                  id: ele?.["id"],
                  region: key == "branches" ? ele["region"] : "",
                  regionCode: key == "branches" ? ele["regionCode"] : "",
                });
              }
            });
            saveMasterData({ userAssignedBranches: arr });
          }
          saveMasterData({ [key]: newArray });
        },
        failure: (err: any) => {
          console.error(err);
        },
      } as getRequestInterface);
    }
  };

  const getuserInfo = async (data: any) => {
    const url = BASE_URL + GET_USER_INFO;
    const id = data?.id;
    if (!id || id == null) {
      await getAPIRequest({
        url: url,
        success: (response: any) => {
          const data = response?.data?.data;
          const objforMapToSelect = {
            suggest: data,
            keyToSet: "idToStreamName",
            order: true,
          };
          const newSubjectArray = data?.subjects.map((ele: any) => {
            return { label: ele.subjectName, key: ele.id, value: ele.id };
          });
          const streamsArray = mapToArrayForSelect(objforMapToSelect);
          const newstreamsArray = streamsArray.filter(
            (item) =>
              item.label == "SOF" || item.label == "SOM" || item.label == "SOE"
          );
          userinfoDispatch({
            ...data,
            id: data?.id,
            facId: data?.id,
            user_name: data?.name,
            username: data?.username,
            email: data?.email,
            branch: data?.branch,
            department: data?.department,
            role: data?.role,
            class_id: data?.class_id,
            branchId: data?.branchId,
            branchName: data?.branchName,
            idToStreamName: data.idToStreamName,
            employeeId: data?.employeeId,
            subjects: data?.subjects,
            subjectsListing: newSubjectArray,
            syllabusCompliance: true,
            userStreams:
              newstreamsArray && Array.isArray(newstreamsArray)
                ? newstreamsArray
                : [],
            fexRole: data?.fexRole,
            region: data?.region,
          } as IUserInfo);
          sendRefreshEventToGTAG(data?.email, data?.fexRole);
        },
        failure: (err: any) => {
          if (user) {
            logout();
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            ToastDispatch({
              isOpen: true,
              type: "Error",
              message: err?.message,
            });
          }
        },
      } as getRequestInterface);
    }
  };
  // // toggles collapse between mini sidenav and normal
  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-hidden")) {
      document.body.classList.remove("g-sidenav-hidden");
      document.body.classList.add("g-sidenav-pinned");
      setSidenavOpen(true);
    } else {
      document.body.classList.add("g-sidenav-hidden");
      document.body.classList.remove("g-sidenav-pinned");
      setSidenavOpen(false);
    }
  };
  //FreshChat ChatBot initialization

  // function initiateCall(userInfo: any) {
  //   initialize(document, "Freshchat-js-sdk", userInfo);
  // }
  // function initialize(i: any, t: any, user: any) {
  //   console.log(userInfo, "userInfowidget", user);
  //   let e;
  //   i.getElementById(t)
  //     ? initFreshChat(userInfo)
  //     : (((e = i.createElement("script")).id = t),
  //       (e.async = !0),
  //       (e.src = "https://aakash-help-support.freshchat.com/js/widget.js"),
  //       (e.onload = initFreshChat),
  //       i.head.appendChild(e));
  // }
  // function initFreshChat(userInfo: any) {
  //   (window as any).fcWidget.init({
  //     token: "3f36a1ac-41f3-4e84-a1ac-a070b3a063db",
  //     host: "https://aakash-help-support.freshchat.com",
  //   });
  //   (window as any).fcWidget.setExternalId(userInfo.employeeId);
  //   (window as any).fcWidget.user.setFirstName(userInfo.name);
  //   (window as any).fcWidget.user.setLastName(userInfo.fexRole);
  //   (window as any).fcWidget.user.setPhone(userInfo.id);
  //   (window as any).fcWidget.user.setPhoneCountryCode("+91");
  //   // To set user properties
  //   (window as any).fcWidget.user.setProperties({
  //     plan: "Pro", // meta property 1
  //     status: "Active", // meta property 2
  //   });
  //   (window as any).fcWidget.user.setMeta({
  //     Role: userInfo.fexRole,
  //     Stream: Object.values(userInfo?.idToStreamName).join(","),
  //     Region: userInfo.region,
  //     Branch: userInfo.branch,
  //   });
  // }

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://aakash-help-support.freshchat.com/js/widget.js";
  //   script.addEventListener("load", () => {
  //     try {
  //       initiateCall(userInfo);
  //     } catch (e) {
  //       console.log("error in Botpress.jsx", e);
  //     }
  //   });
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, [userInfo]);

  if (!user) {
    return <Navigate to="/" />;
  }
  return (
    <div className="adminlayout">
      <Sidebar
        logo={{
          innerLink: "/",
          imgSrc: require("Assets/Images/aakashlogo.png"),
          imgAlt: "...",
        }}
        routes={routes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        isMiniSideBar={isMiniSideBar}
        setIsMiniSideBar={setIsMiniSideBar}
      />
      <div className="d-flex flex-column">
        <AppBar
          toggleSidenav={toggleSidenav}
          isMiniSideBar={isMiniSideBar}
          setIsMiniSideBar={setIsMiniSideBar}
          showNotification={showNotification}
          setShowNotification={setShowNotification}
        />
        {versionUpdateNeeded.isShow ? (
          <CustomModal
            size="md"
            modal={versionUpdateNeeded.isShow}
            title={"Update Available"}
            toggle={() => {
              window.location.reload();
              localStorage.setItem("version-update-needed", "false");
              VersionUpdateDispatch({
                isShow: false,
                message: "",
              });
            }}
          >
            <div className="w-100 d-flex flex-column p-5 justify-content-center align-items-center gap-4">
              <Typography variant="h4" color="black">
                {versionUpdateNeeded.message}
              </Typography>
              <Button
                color="aeslPrimary"
                onClick={() => {
                  window.location.reload();
                  localStorage.setItem("version-update-needed", "false");
                  VersionUpdateDispatch({
                    isShow: false,
                    message: "",
                  });
                }}
              >
                Update
              </Button>
            </div>
          </CustomModal>
        ) : null}
        {successMessageInfor.isShow ? (
          <SuccessfullyMessageBar message={successMessageInfor.message} />
        ) : null}
        <ContainerDivAdmin screen={screen} width={width}>
          {outlet}
        </ContainerDivAdmin>
      </div>
    </div>
  );
};
export const AdminRoutes = (routes: any): JSX.Element => {
  return (
    <>
      {routes.map((item: any, index: number) => {
        return (
          <Route
            key={index}
            path={item.path}
            element={
              <RequireAuth userroles={item.access} item={item}>
                {item.component}
              </RequireAuth>
            }
          />
        );
      })}
      {dynamicRoutes.map((item: any, index: number) => {
        return (
          <Route
            key={index}
            path={item.path}
            element={
              <RequireAuth userroles={item.access} item={item}>
                {item.component}
              </RequireAuth>
            }
          />
        );
      })}
    </>
  );
};
